import { LAYER_TYPE, LAYER_IDS } from '@tmapy/config';
import { batch } from '@tmapy/redux';
import { actionInteractionSelectFeatures, actionSetLayerFeatures, featureToGeoJSONObject, actionSetVectorTileHiddenFeatures, } from '@tmapy/mapcore';
import { getJoinedFeatures } from '../utils/joinTools/getJoinedFeatures';
import { actionUnhideTileAllFeaturesByLayer } from '.';
import { actionPrepareSaveFeatures } from './saveEditedFeature';
export const actionIntersection = (payload) => async (dispatch, getState) => {
    const state = getState();
    const { joinFeatures, editFeature, highlightFeature } = getState().editTools.joinLineTool;
    const snapLayer = state.mapCore.layers.find((layer) => layer.type === LAYER_TYPE.VECTOR && layer.id === LAYER_IDS.EDIT_TOOLS_SNAP);
    const snapFeatures = snapLayer?.features;
    if (!snapFeatures.length) {
        const editLayer = state.mapCore.layers.find((layer) => layer.type === LAYER_TYPE.VECTOR && layer.id === LAYER_IDS.EDIT_TOOLS_MODIFY);
        const lastEditFeatures = editLayer?.features;
        const lastEditedLayer = lastEditFeatures[0]?.properties?._originLayerId;
        lastEditFeatures.forEach((feature) => {
            if (feature.properties?._originLayerId !== lastEditedLayer) {
                console.error('actionSelectFeature: features have different originLayerId!');
            }
        });
        const editedLayerFeatures = payload.features.filter((layerFeature) => layerFeature.layerId === LAYER_IDS.EDIT_TOOLS_HIGHLIGHT);
        const editedOLFeatures = editedLayerFeatures.map((layerFeature) => layerFeature.feature);
        if (editedOLFeatures.length === 0) {
            return;
        }
        const geoJSONFeatures = editedOLFeatures.map(featureToGeoJSONObject);
        batch('actionIntersection', () => {
            if (lastEditedLayer) {
                dispatch(actionUnhideTileAllFeaturesByLayer(LAYER_IDS.EDIT_TOOLS_MODIFY, lastEditedLayer));
            }
            dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_HIGHLIGHT, []));
            dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_MODIFY, geoJSONFeatures));
        });
        /**
         * TODO - refactor effects vs. middleware ?
         * nastava problem s navazujicim useEffect (mapcore/VectorTileLayers)
         * do state tato akce ulozi co ma (props.hiddenFeatureIds)
         * komponenta a jeji useEffect nezareaguje
         * -> proto tento HACK (setImmediate)
         */
        setImmediate(() => {
            dispatch(actionInteractionSelectFeatures(LAYER_IDS.EDIT_TOOLS_MODIFY, [editedOLFeatures[0]]));
        });
    }
    else if (joinFeatures?.length) {
        if (!editFeature) {
            throw new Error(`[actionIntersection] editFeature`);
        }
        const joinedFeature = getJoinedFeatures(joinFeatures);
        const saveFeature = {
            ...editFeature,
            geometry: { ...joinedFeature.geometry },
        };
        const saveLayerId = editFeature?.properties?._originLayerId;
        const saveFeatureId = editFeature?.id;
        const deleteLayerId = highlightFeature?.properties?._originLayerId;
        const deleteFeatureId = highlightFeature?.id;
        if (!deleteLayerId || !deleteFeatureId || !saveLayerId || !saveFeatureId) {
            throw new Error('[joinLineTool] Cannot save new updated Feature');
        }
        await dispatch(
        // create new
        actionPrepareSaveFeatures([
            {
                layerId: saveLayerId,
                featureId: null,
                feature: saveFeature,
            },
            {
                layerId: saveLayerId,
                featureId: saveFeatureId,
                feature: null,
            },
            {
                layerId: deleteLayerId,
                featureId: deleteFeatureId,
                feature: null,
            },
        ])).meta.responsePromise;
        // hide original highlighted
        dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_MODIFY, []));
        dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_HIGHLIGHT, []));
        dispatch(actionSetVectorTileHiddenFeatures(saveLayerId, []));
    }
};
//# sourceMappingURL=intersection.js.map